import {SiteClient} from 'datocms-client';

const client = new SiteClient('7ac4df0eb4ad7440d4dc04174d7619');

export function getEvents() {
  return client.items.all({ 'filter[type]': 'event' });
}



// WEBPACK FOOTER //
// ./src/js/services/cms.service.js